import React from 'react';

import { Button, Text } from '@mantine/core';

import { IntlHelpers } from 'helpers/IntlHelpers';

import { useComponentContext } from 'components/component-datasheet/hooks/use-component-context';
import { Datasheet } from 'components/datasheet/Datasheet';
import { DatasheetMode, useDatasheetMode } from 'components/datasheet/DatasheetMode';
import { useDistributorPrice } from 'hooks/use-distributor-price';
import { InternalTrackingService } from 'services/InternalTrackingService';

import type { Manufacturer } from '@/payload-types';

const DistributorPricing = () => {
    const mode = useDatasheetMode();
    const { component } = useComponentContext();
    const { distributorPrice } = useDistributorPrice(component.id);

    if (mode !== DatasheetMode.VIEW || !distributorPrice) {
        return null;
    }

    const distributor = distributorPrice.distributor as Manufacturer;
    const distributorName = distributor?.name || 'Distributor';

    return (
        <Datasheet.Section title="Distributor Pricing">
            <Datasheet.Table header={{ label: 'Distributors' }} isPublic>
                <Datasheet.TableRow name="distributorPrice" label={distributorName} noMetadata alwaysShow>
                    <Datasheet.TableValue>
                        <Text inherit fw={700}>
                            {IntlHelpers.formatPrice(distributorPrice.price)}
                        </Text>
                        {distributorPrice.leadTime && (
                            <Text inherit c="dimmed">
                                Lead time: {distributorPrice.leadTime}
                            </Text>
                        )}
                        {distributorPrice.url && (
                            <Button
                                component="a"
                                href={distributorPrice.url}
                                {...InternalTrackingService.link(
                                    'product.distributor-price.cta',
                                    'View distributor pricing',
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                                size="xs"
                                ml="auto"
                                style={{ pointerEvents: 'all' }}
                            >
                                View at {distributorName}
                            </Button>
                        )}
                    </Datasheet.TableValue>
                </Datasheet.TableRow>
            </Datasheet.Table>
        </Datasheet.Section>
    );
};

export { DistributorPricing };
